import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import ReactDatePicker from "react-datepicker";
import { Table } from "react-bootstrap";
import moment from "moment";
import { useParams, useNavigate } from "react-router-dom";
import { API_URL } from "../../../../constants";
import { FaSpinner } from "react-icons/fa";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import { getDay } from "date-fns";
import LeaveHistory from "../ApplyLeave/LeaveHistory";
import LeaveSummary from "../ApplyLeave/LeaveSummary";

const ViewLeaveDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  let today = moment().format("DD-MMM-YYYY");
  const [leaveDetails, setLeaveDetails] = useState([]);
  const [daysDifference, setDaysDifference] = useState(1);
  const [displayedDates, setDisplayedDates] = useState([
    moment().format("DD-MMM-YYYY"),
  ]);
  const [errors, setErrors] = useState({});
  const [leaveSummary, setLeaveSummary] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState(null);

  const [leaveoptions, setLeaveOptions] = useState([]);
  const [leaveHistory, setLeaveHistory] = useState([]);
  const [statusoptions, setStatusOptions] = useState([]);
  const [lineData, setLineData] = useState([]);
  const [submitted, setSubmit] = useState(false);
  const [formData, setFormData] = useState({
    Purpose: "",
    FromDate: today,
    ToDate: today,
    leaveApplicationLines: [],
  });
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("View Leave Details"));
    fetchData(id);
  }, []);

  const formatDate = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const location = useLocation();
  const { disabledDatess } = location.state || [];

  const [holidayDate, setHolidayDate] = useState(disabledDatess);
  const [pageLoading, setPageLoading] = useState(true);

  const fetchLeaveDetails = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}apply-leave`);
      const data = response?.data?.leaveSummary;
      const leaveHistory = response?.data?.leaveHistory;
      setLeaveHistory(leaveHistory);
      setLeaveDetails(data);

      // Filter out the unwanted LeaveID and LeaveType
      const filteredData = data.filter(
        (comp) => !(comp.LeaveID === 3 && comp.LeaveType === "Total")
      );

      const leaveopt = filteredData.map((comp) => ({
        value: comp.LeaveID,
        label: comp.LeaveType,
      }));
      setLeaveOptions(leaveopt);
      setPageLoading(false);
    } catch (error) {
      console.error("Error fetching skills:", error);
    }
  };
  useEffect(() => {
    fetchLeaveDetails();
  }, []);

  const filteredLeaveDetails = leaveDetails.filter((item) =>
    ["C-Off", "EL", "LOP", "Total"].includes(item.LeaveType)
  );

  const countWeekdays = (startDate, endDate) => {
    let count = 0;
    let currentDate = moment(startDate);

    while (
      currentDate.isBefore(endDate) ||
      currentDate.isSame(endDate, "day")
    ) {
      if (isWeekday(currentDate.toDate())) {
        count++;
      }
      currentDate.add(1, "days");
    }
    return count;
  };

  useEffect(() => {
    if (formData.FromDate && formData.ToDate) {
      const daysDiff = countWeekdays(
        moment(formData.FromDate, "DD-MMM-YYYY"),
        moment(formData.ToDate, "DD-MMM-YYYY")
      );
      setDaysDifference(daysDiff);
      setDisplayedDates(generateDateRange(formData.FromDate, formData.ToDate));
    }
  }, [formData]);

  const handleDateChange = (date, field) => {
    const formattedDate = moment(date).format("DD-MMM-YYYY");

    if (field === "FromDate") {
      setFormData({
        ...formData,
        FromDate: formattedDate,
        ToDate: formattedDate, // Reset ToDate to FromDate to avoid invalid ranges
      });

      const daysDiff = countWeekdays(
        moment(formattedDate, "DD-MMM-YYYY"),
        moment(formattedDate, "DD-MMM-YYYY")
      );

      setDaysDifference(daysDiff);
      setDisplayedDates(generateDateRange(formattedDate, formattedDate));
    } else if (field === "ToDate") {
      // Check if ToDate is before FromDate
      const fromDateMoment = moment(formData.FromDate, "DD-MMM-YYYY");
      const toDateMoment = moment(formattedDate, "DD-MMM-YYYY");

      if (toDateMoment.isBefore(fromDateMoment, "day")) {
        // Show error toast
        toast.error("To Date cannot be before From Date!");
        return; // Exit without updating state
      }

      // If valid, update the state
      setFormData({ ...formData, [field]: formattedDate });

      const daysDiff = countWeekdays(fromDateMoment, toDateMoment);
      setDaysDifference(daysDiff);
      setDisplayedDates(generateDateRange(formData.FromDate, formattedDate));
    }
  };
  // Function to generate the date range excluding weekends

  const generateDateRange = (fromDate, toDate) => {
    let currentDate = moment(fromDate, "DD-MMM-YYYY");
    const endDate = moment(toDate, "DD-MMM-YYYY");
    let dates = [];

    while (currentDate <= endDate) {
      if (
        currentDate.isoWeekday() !== 6 &&
        currentDate.isoWeekday() !== 7 &&
        !disabledDatess?.some((disabledDate) =>
          moment(disabledDate).isSame(currentDate, "day")
        )
      ) {
        // Exclude Saturday (6) and Sunday (7)
        dates.push(currentDate.format("DD-MMM-YYYY"));
      }
      currentDate = currentDate.add(1, "days");
    }

    return dates;
  };

  const isWeekday = (date) => {
    const day = getDay(date); // Get the day of the week (0 = Sunday, 6 = Saturday)

    // Check if the date is a weekend (Saturday or Sunday)
    const isWeekend = day === 0 || day === 6;

    // Check if the date is a holiday (exists in the disabledDates array)
    const isHoliday = disabledDatess?.some(
      (disabledDate) => moment(disabledDate).isSame(date, "day") // Compare day/month/year
    );

    // Allow only weekdays that are not holidays
    return !isWeekend && !isHoliday;
  };
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });

    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
  };
  const validateForm = () => {
    const newErrors = {};

    if (!formData.Purpose?.trim()) {
      newErrors.Purpose = "Purpose is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const fetchData = async (id) => {
    try {
      const response = await GetServiceCaller(`${API_URL}apply-leave/${id}`);

      if (response.status === 200) {
        const leaveData = response?.data?.leaveList;
        const lineData = response?.data?.leaveLine;
        setLineData(lineData);
        const leaveSummary = response?.data?.leaveSummary;
        setLeaveSummary(leaveSummary);
        const leaveHistory = response?.data?.leaveHistory;
        setLeaveHistory(leaveHistory);

        const statusoption = response?.data?.status;
        const filteredStatus = statusoption.filter(
          (comp) => comp.value === 1132 || comp.value === 824
        );
        const statusopt = filteredStatus.map((comp) => ({
          value: comp.value,
          label: comp.text,
        }));
        const statusoptt = statusoption.map((comp) => ({
          value: comp.value,
          label: comp.text,
        }));
        setStatusOptions(statusoptt);

        if (leaveData) {
          const { Purpose, FromDate, ToDate } = leaveData;
          setFormData({
            id: id || "",
            Purpose: Purpose || "",
            FromDate: FromDate ? moment(FromDate).format("DD-MMM-YYYY") : "",
            ToDate: ToDate ? moment(ToDate).format("DD-MMM-YYYY") : "",
            ApplicationStatus_123: leaveData?.ApplicationStatus_123,
          });
        } else {
          console.error("Leave Data not found with ID:", id);
        }
      } else {
        console.error(
          "Failed to fetch Leave details. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Leave details:", error);
    }
  };

  const handleCancel = () => {
    navigate("/approve-leave");
  };

  let remainingCOff =
    filteredLeaveDetails.find((leave) => leave.LeaveType === "C-Off")
      ?.LeaveBalance || 0;
  let remainingEL =
    filteredLeaveDetails.find((leave) => leave.LeaveType === "EL")
      ?.LeaveBalance || 0;

  if (pageLoading) {
    return (
      <>
        <p class="position-absolute top-50 start-50 translate-middle text-center">
          <FaSpinner class="spinner" />
        </p>
      </>
    );
  } else {
    return (
      <>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-lg-7 apply-Leave">
              <div className="container-fluid" id="skill-table-area">
                <form>
                  <div className="row">
                    <div className="col-md-6">
                      <label for="leave-type" class="form-label">
                        Employee
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="EmployeeName"
                        aria-describedby="EmployeeName"
                        name="EmployeeName"
                        value={leaveSummary?.[0]?.EmployeeName || ""}
                        disabled
                      />
                    </div>
                    <div className="col-md-6">
                      <label for="leave-type" class="form-label">
                        Status
                      </label>
                      <Select
                        value={statusoptions.find(
                          (option) =>
                            option.value === formData.ApplicationStatus_123
                        )}
                        options={statusoptions}
                        isDisabled={true}
                        onChange={(selectedOption) =>
                          setFormData({
                            ...formData,
                            ApplicationStatus_123: selectedOption
                              ? selectedOption.value
                              : null,
                          })
                        }
                      />
                    </div>
                    <div className="mt-2">
                      <label for="leave-type" class="form-label">
                        Purpose
                      </label>
                      <textarea
                        type="text"
                        className={`form-control ${
                          errors.Purpose ? "is-invalid" : ""
                        }`}
                        id="Purpose"
                        aria-describedby="Purpose"
                        name="Purpose"
                        value={formData.Purpose}
                        // onChange={handleInputChange}
                        disabled
                      />
                      {errors.Purpose && (
                        <div className="invalid-feedback">{errors.Purpose}</div>
                      )}
                    </div>
                    <div className="col-sm-12 col-md-5 mt-2">
                      <label htmlFor="TargetDate" className="form-label">
                        From Date
                      </label>

                      <ReactDatePicker
                        autoComplete="off"
                        changeYear
                        changeMonth
                        showPopperArrow
                        showIcon
                        icon="fa fa-calendar"
                        className="form-control"
                        format="d-MM-YYYY"
                        name="FromDate"
                        id="FromDate"
                        filterDate={isWeekday}
                        disabled={true}
                        // onChange={(date) => handleDateChange(date, "FromDate")}
                        selected={
                          formData.FromDate
                            ? moment(formData.FromDate, "DD-MMM-YYYY").toDate()
                            : null
                        }
                        dateFormat="dd-MMM-yyyy"
                        // minDate={moment().startOf("month").toDate()}
                      />
                    </div>
                    <div className="col-sm-12 col-md-5 mt-2">
                      <label htmlFor="TargetDate" className="form-label">
                        To Date
                      </label>

                      <ReactDatePicker
                        autoComplete="off"
                        // minDate={new Date()}
                        changeYear
                        changeMonth
                        showPopperArrow
                        showIcon
                        icon="fa fa-calendar"
                        className="form-control"
                        format="d-MM-YYYY"
                        name="ToDate"
                        id="ToDate"
                        filterDate={isWeekday}
                        disabled={true}
                        // onChange={(date) => handleDateChange(date, "ToDate")}
                        selected={
                          formData.ToDate
                            ? moment(formData.ToDate, "DD-MMM-YYYY").toDate()
                            : null
                        }
                        dateFormat="dd-MMM-yyyy"
                        // minDate={moment().startOf("month").toDate()}
                      />
                    </div>
                    <div className="col-sm-12 col-md-2 mt-2">
                      <div class="mb-3">
                        <label for="days" class="form-label">
                          No. of Days
                        </label>
                        <input
                          type="text"
                          className="form-control text-end"
                          id="days"
                          aria-describedby="days"
                          name="days"
                          value={
                            daysDifference ? daysDifference : lineData.length
                          }
                          disabled
                        />
                      </div>
                    </div>
                    <div className="col-md-12 mt-4">
                      <Table bordered>
                        <thead id="thcolor" className="text-center">
                          <tr>
                            <th className="py-1 px-2">Sr. No.</th>
                            <th className="py-1 px-2">Date</th>
                            <th className="py-1 px-2">Leave Type</th>
                          </tr>
                        </thead>
                        <tbody>
                          {lineData.map((item, index) => {
                            const selectedOption = leaveoptions.find(
                              (option) =>
                                option.value.toString() ===
                                item.LeaveID.toString()
                            );
                            return (
                              <tr key={index}>
                                <td className="text-center py-1 px-2">{index + 1}</td>
                                <td className="text-center py-1 px-2">
                                  {moment(item.Date).format("DD-MMM-YYYY")}
                                </td>
                                <td className="py-1 px-2">
                                  <Select
                                    value={selectedOption}
                                    options={leaveoptions}
                                    isDisabled={true}
                                  />
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                    </div>
                  </div>

                  <div className="text-end mt-2">
                    <button
                      type="button"
                      className="cancel-btn me-2"
                      onClick={handleCancel}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>

            <div className="col-12 col-lg-5 apply-Leave">
                <LeaveSummary leaveDetails={leaveSummary} />
                <LeaveHistory
                  leaveHistory={leaveHistory}
                  showAction={false}
                  title="Leave History"
                />
            </div>
          </div>
        </div>
      </>
    );
  }
};

export default ViewLeaveDetails;
